const clearDataLayer = (dataLayer: object[]) => {
  dataLayer.push({ ecommerce: null });
};

export const createTrackingEvent = (event: Record<string, unknown>): void => {
  const { dataLayer = [] } = window;
  if (event['ecommerce']) {
    clearDataLayer(dataLayer);
  }
  dataLayer.push(event);
};
